import script from "./ConfigSign.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigSign.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigSign.vue?vue&type=style&index=0&id=01b2251e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b2251e"]])

export default __exports__